import {
  evaluateCondition as evaluateGrammarCondition,
  type ParsedCondition,
} from "@autodromo/template-syntax";

export interface EvaluateConditionArgs {
  condition: ParsedCondition;
  context: Record<string, string>;
}

export const evaluateCondition = ({
  condition,
  context,
}: EvaluateConditionArgs): boolean =>
  evaluateGrammarCondition({ condition, value: context[condition.path] });
